import { FormattedMessage } from "react-intl";

const AssetConfigurationManagement = () => {
    return (
        <div>
            <p>
                <FormattedMessage
                    id="JiraServiceManagementPricingPageTeam24.features.assetConfigurationManagement.content.body"
                    defaultMessage="Manage the lifecycle of assets and services. Gain visibility into dependencies, troubleshoot incidents, and minimize risk."
                />
            </p>
        </div>
    );
};

export default AssetConfigurationManagement;
